import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {
  alabaster,
  black,
  denim,
  grayscale,
  ravenBlack,
  white,
} from '/theme/color/on.color';
import {alto} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  base: {
    marginTop: 20,
    color: black,
    paddingHorizontal: 0,
  },
  titleText: {
    color: black,
  },
  noteField: {
    marginBottom: indent * 0.3,
    marginTop: 0,
    paddingHorizontal: indent * 0.35,
  },
  selectedIcon: {
    fontSize: 22,
    color: denim,
  },
  unSelectedIcon: {
    fontSize: 22,
    borderColor: grayscale,
    borderStyle: 'solid',
    borderWidth: 2.5,
    borderRadius: 2,
    color: white,
  },
  iconContainer: {
    width: 22,
    height: 22,
  },
  flexDirection: {
    flexDirection: 'row',
    paddingLeft: indent * 0.45,
    paddingRight: 10,
    marginVertical: 20,
  },
  header: {
    fontSize: 16,
    fontWeight: 'bold',
    marginLeft: indent * 0.3,
  },
  footerText: {
    fontSize: 12,
    fontWeight: '400',
    marginBottom: 30,
    color: ravenBlack,
    marginHorizontal: indent * 0.3,
  },
  taskItemContainer: {
    flexDirection: 'row',
    borderRadius: 8,
    borderStyle: 'solid',
    borderWidth: 1,
    marginBottom: indent * 0.5,
    paddingLeft: indent,
    paddingRight: indent * 0.5,
    paddingTop: indent,
    paddingBottom: indent,
  },
  enabledContainer: {
    backgroundColor: alabaster,
    borderColor: white,
  },
  disabledContainer: {
    backgroundColor: white,
    borderColor: alto,
  },
});
